import classNames from 'classnames';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';
import React from 'react';
import { useLocation } from 'react-use';

import Awards from '@/components/AboutUs/Awards';
import Banner from '@/components/AboutUs/Banner';
import BrandIntroduction from '@/components/AboutUs/BrandIntroduction';
import Journey from '@/components/AboutUs/Journey';
import Mission from '@/components/AboutUs/Mission';
import Layout from '@/components/Layout';

import styles from './style.module.scss';

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'aboutus',
        'path',
        'form',
      ])),
    },
  };
};

const AboutUs = () => {
  const { t } = useTranslation(['aboutus', 'common']);
  const state = useLocation();

  return (
    <div className={classNames(styles.container)}>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-关于我们-title'),
          description: t('common:seo-关于我们-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-关于我们-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-关于我们-title')}</title>
        <meta
          name="description"
          content={t('common:seo-关于我们-description')}
        />
        <meta name="keywords" content={t('common:seo-关于我们-关键词')} />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-关于我们-title')}
        />
      </Head>
      {/* banner  */}
      <Banner />

      {/* 悟空使命 */}
      <Mission />

      {/* 品牌介绍 */}
      <BrandIntroduction />

      {/* 悟空历程 */}
      <Journey />
      {/* 奖项 */}
      <Awards />
    </div>
  );
};

export default AboutUs;

AboutUs.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
